import React from 'react';
import { bool, func, number, string } from 'prop-types';
import CompensationSummaryCard from '../CompensationSummaryCard/CompensationSummaryCard';
import './OverallComments.scss';

class OverallComments extends React.Component {
  static propTypes = {
    checked: bool,
    compositeAdjustment: number,
    compositeComment: string,
    onToggle: func,
    isConfigVisible: bool
  };

  render() {
    const { checked, compositeAdjustment, compositeComment, onToggle, isConfigVisible } = this.props;
    const hasComment = compositeComment && compositeComment.length > 0;
    const hasAdjustment = compositeAdjustment && compositeAdjustment !== 1;
    const titleText =
      hasComment && hasAdjustment
        ? 'Overall Comments & Adjustment'
        : hasComment && !hasAdjustment
        ? 'Overall Comments'
        : 'Overall Adjustment';

    if (!hasComment && !hasAdjustment) return null;

    return (
      <CompensationSummaryCard
        cardTitle={titleText}
        checked={checked}
        onToggle={onToggle}
        isConfigVisible={isConfigVisible}
      >
        <div className="comp-sum-overall-comments">
          {hasComment && (
            <div className="comp-sum-overall-comments__comment">
              {hasComment && hasAdjustment && (
                <div className="comp-sum-overall-comments__comment-title">Overall Comments</div>
              )}
              <div>{compositeComment}</div>
            </div>
          )}
          {hasAdjustment && (
            <div className="comp-sum-overall-comments__adjustment">
              {hasComment && hasAdjustment && (
                <div className="comp-sum-overall-comments__adjustment-title">Overall Adjustment</div>
              )}
              <div>{compositeAdjustment}</div>
            </div>
          )}
        </div>
      </CompensationSummaryCard>
    );
  }
}

export default OverallComments;
